import {
  APIClient,
  setAuthorization,
  clearAuthorization,
} from "../../../helpers/api_helper";
import { getWorkspaces } from "../../../helpers/kronaly_helper";
import * as url from "../../../helpers/url_helper";
import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
  loginBegin,
} from "./reducer";

const api = new APIClient();

/**
 * Inicia sesión y navega al destino. `nextPath` permite a páginas que
 * dependen de auth (p. ej. /invitations/:token) redirigir al usuario
 * de vuelta al flujo en curso tras el login. Se valida que `nextPath`
 * sea relativo a `/` (no admitir URLs absolutas) para evitar open-redirect.
 */
export const loginUser = (user, history, nextPath = null) => async (dispatch) => {
  try {
    dispatch(loginBegin());

    const response = await api.create(url.POST_KRONALY_LOGIN, {
      email: user.email,
      password: user.password,
    });

    const inner = response?.data ?? response;
    const access_token = inner?.access_token;

    if (access_token) {
      const userData = { access_token };
      localStorage.setItem("authUser", JSON.stringify(userData));
      setAuthorization(access_token);
      dispatch(loginSuccess(userData));

      try {
        const wsResponse = await getWorkspaces();
        const list = wsResponse?.data ?? wsResponse;
        const arr = Array.isArray(list) ? list : [];
        if (arr.length > 0 && arr[0].id) {
          localStorage.setItem("kronaly_workspace_id", arr[0].id);
        }
      } catch (_) {
        /* sin workspaces aún */
      }

      const safeNext =
        typeof nextPath === "string" &&
        nextPath.startsWith("/") &&
        !nextPath.startsWith("//")
          ? nextPath
          : "/resumen";
      history(safeNext);
    }
  } catch (error) {
    const msg =
      typeof error === "string"
        ? error
        : error?.message || "Error de inicio de sesión";
    dispatch(apiError({ data: msg }));
  }
};

export const logoutUser = (history) => async (dispatch) => {
  try {
    const stored = localStorage.getItem("authUser");
    if (stored) {
      await api.create(url.POST_KRONALY_LOGOUT, {}).catch(() => {});
    }
  } catch (_) {
    /* silencioso */
  } finally {
    localStorage.removeItem("authUser");
    localStorage.removeItem("kronaly_workspace_id");
    clearAuthorization();
    dispatch(logoutUserSuccess(true));
    if (history) history("/login");
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    return dispatch(reset_login_flag());
  } catch (error) {
    const msg =
      typeof error === "string"
        ? error
        : error?.message || String(error);
    dispatch(apiError({ data: msg }));
  }
};
